import callNativeMethod from './callNativeMethod';
import NATIVEFUNCTION_TYPE from './nativeFunctionType';
import myInterface from './myInterface';
import checkIfInterfaceExist from './checkIfInterfaceExist';

/**
 * @param {*} event
 * @return {*}
 */
const analyticsEvent = (event) => {
  console.log(event);
  const methodBody = {
    functionName: NATIVEFUNCTION_TYPE.analyticsEvent,
    parameters: {
      argument1: event.event_category,
      argument2: event.event_action,
      argument3: 'Role',
    },
  };
  try {
    console.log(methodBody);
    callNativeMethod(methodBody);
    return true;
  } catch (error) {
    if (checkIfInterfaceExist('analyticsEvent')) {
      return myInterface.analyticsEvent(JSON.stringify(event));
    }
  }
};

export default analyticsEvent;
